import React, { useState } from 'react';
import CryptoJS from 'crypto-js';

function Auth({ onLogin }) {
    const [isLogin, setIsLogin] = useState(true);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!isLogin && password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        const endpoint = isLogin ? '/api/login' : '/api/register';
        
        try {
            const res = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
            
            const data = await res.json();
            
            if (!res.ok) throw new Error(data.error || 'Something went wrong');

            if (isLogin) {
                // Derive encryption key from credentials
                const encryptionKey = CryptoJS.SHA256(username + password).toString();
                
                // Store auth token (session)
                localStorage.setItem('token', data.token);
                
                // Pass both to App
                onLogin(data.token, encryptionKey);
            } else {
                // Auto-login after register or just switch to login? 
                // Let's switch to login view for simplicity + confirmation
                setIsLogin(true);
                setError('Registration successful! Please login.');
            }
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
            <h2>{isLogin ? 'Login' : 'Register'}</h2>
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '10px' }}>
                    <label>Username:</label>
                    <input 
                        type="text" 
                        value={username} 
                        onChange={e => setUsername(e.target.value)} 
                        required 
                        style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                    />
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <label>Password:</label>
                    <input 
                        type="password" 
                        value={password} 
                        onChange={e => setPassword(e.target.value)} 
                        required 
                        style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                    />
                </div>
                {!isLogin && (
                    <div style={{ marginBottom: '10px' }}>
                        <label>Confirm Password:</label>
                        <input 
                            type="password" 
                            value={confirmPassword} 
                            onChange={e => setConfirmPassword(e.target.value)} 
                            required 
                            style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                        />
                    </div>
                )}
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <button type="submit" style={{ width: '100%', padding: '10px', cursor: 'pointer' }}>
                    {isLogin ? 'Login' : 'Register'}
                </button>
            </form>
            <p style={{ marginTop: '10px', textAlign: 'center' }}>
                {isLogin ? "Need an account? " : "Have an account? "}
                <button 
                    onClick={() => { setIsLogin(!isLogin); setError(''); }} 
                    style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                >
                    {isLogin ? 'Register' : 'Login'}
                </button>
            </p>
        </div>
    );
}

export default Auth;